<template>
  <Accordion :activeIndex="0">
    <AccordionTab header="Thêm nhân viên hỗ trợ">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col p-col-12 p-md-12 p-lg-6">
            <Panel header="Thêm nhân viên hỗ trợ đặt lịch">
              <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col p-col-12 p-md-8 p-lg-8">
                  <label>Chọn thành viên</label>
                    <Dropdown v-model="managerBooking.zaloId" :options="listCustomer" optionLabel="name" optionValue="id" placeholder="Chọn tài khoản" :filter="true" style="height: 35px" >
                      <template #option="slotProps">
                        <div class="flex align-items-center">
                          <img v-if="slotProps.option.imageUrl" :src=slotProps.option.imageUrl style="width: 20px; margin-right: 3px" />
                          <label style="width: 20px">{{ slotProps.option.name }}</label>
                        </div>
                      </template>
                    </Dropdown>
                </div>
                <div class="p-field p-col p-col-12 p-md-4 p-lg-4">
                  <label>Thêm</label>
                  <Button label="Thêm" icon="pi pi-plus-circle" iconPos="left" @click="addMember()" :disabled="!managerBooking.zaloId" />
                </div>
              </div>
            </Panel>
              </div>
              <div class="p-field p-col p-col-12 p-md-12 p-lg-6">
            <Panel header="Danh sách nhân viên hỗ trợ đặt lịch">
              <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col p-col-12 p-md-12 p-lg-12">
                  <DataTable
                      :loading="isLoading"
                      :value="listManagerBooking" :paginator="true" stripedRows :rows="10"
                      :rowsPerPageOptions="[10,25,50]" :rowHover="true"
                      v-model:filters="filters"
                      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                      :globalFilterFields="['zaloName']"
                      currentPageReportTemplate="Có tổng số {totalRecords} thành viên" columnResizeMode="fit | expand">
                    <template #header>
                      <div class="p-d-flex p-jc-between p-ai-center">
                        <Button type="button" icon="pi pi-filter-slash" label="Xoá" class="p-button-outlined" @click="clearFilter()" style="width: 6em"/>
                        <span class="p-input-icon-left" style="width: 18em">
                          <i class="pi pi-search" />
                          <InputText v-model="filters['global'].value" placeholder="Tìm theo tên hoặc số điện thoại" />
                        </span>
                      </div>
                    </template>
                    <Column field="imageLink" header="Ảnh đại diện" sortable>
                    <template #body="slotProps">
                      <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-5 p-md-5">
                          <img :src=slotProps.data.imageLink style="width: 60px" />
                        </div>
                      </div>
                    </template>
                    </Column>
                    <Column field="fullName" header="Họ và tên" sortable></Column>
                    <Column header="Chỉnh sửa">
                      <template #body="slotProps">
                          <Button class="p-button-danger" label="Xoá" icon="pi pi-trash" @click="deleteManager(slotProps.data.id)">
                          </Button>
                      </template>
                    </Column>
                  </DataTable>
                </div>
              </div>
            </Panel>
          </div>
        </div>
    </AccordionTab>
    <AccordionTab header="Thêm bác sĩ khám">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col p-col-12 p-md-12 p-lg-6">
            <Panel header="Thêm bác sĩ khám">
              <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col p-col-12 p-md-8 p-lg-8">
                  <label>Chọn thành viên</label>
                    <Dropdown v-model="doctorExamine.zaloId" :options="listEmployeeInHospital" optionLabel="fullNameWithPhone" optionValue="zaloId" placeholder="Chọn tài khoản" :filter="true" style="height: 35px" >
                    </Dropdown>
                </div>
                <div class="p-field p-col p-col-12 p-md-4 p-lg-4">
                  <label>Thêm</label>
                  <Button label="Thêm" icon="pi pi-plus-circle" iconPos="left" @click="addDoctor()" :disabled="doctorExamine.zaloId"/>
                </div>
              </div>
            </Panel>
              </div>
              <div class="p-field p-col p-col-12 p-md-12 p-lg-6">
            <Panel header="Danh sách bác sĩ khám">
              <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col p-col-12 p-md-12 p-lg-12">
                  <DataTable
                      :loading="isLoading"
                      :value="listDoctorExamine" :paginator="true" stripedRows :rows="10"
                      :rowsPerPageOptions="[10,25,50]" :rowHover="true"
                      v-model:filters="filters"
                      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                      :globalFilterFields="['zaloName']"
                      currentPageReportTemplate="Có tổng số {totalRecords} bác sĩ" columnResizeMode="fit | expand">
                    <template #header>
                      <div class="p-d-flex p-jc-between p-ai-center">
                        <Button type="button" icon="pi pi-filter-slash" label="Xoá" class="p-button-outlined" @click="clearFilter()" style="width: 6em"/>
                        <span class="p-input-icon-left" style="width: 18em">
                          <i class="pi pi-search" />
                          <InputText v-model="filters['global'].value" placeholder="Tìm theo tên hoặc số điện thoại" />
                        </span>
                      </div>
                    </template>
                    <Column field="doctorName" header="Họ và tên" sortable></Column>
                    <Column field="phoneNumber" header="Số điện thoại" sortable></Column>
                    <Column header="Chỉnh sửa">
                      <template #body="slotProps">
                          <Button class="p-button-danger" label="Xoá" icon="pi pi-trash" @click="deleteDoctor(slotProps.data.id)">
                          </Button>
                      </template>
                    </Column>
                  </DataTable>
                </div>
              </div>
            </Panel>
          </div>
        </div>
    </AccordionTab>
  </Accordion>
</template>

<script lang="ts">

import { computed, ref } from 'vue'
import { useToast } from "primevue/usetoast";
import { useRouter } from 'vue-router'
import {useStore} from "vuex";
import {ListCustomer} from "@/models/listCustomer";
import zaloRepository from "@/services/ZaloRepository";
import {FilterMatchMode} from "primevue/api";
import {ManagerCheckinCreate} from "@/models/managerCheckinCreate";
import {ManagerCheckin} from "@/models/managerCheckin";
import {ManagerBookingCreate} from "@/models/managerBookingCreate";
import {ManagerBooking} from "@/models/managerBooking";
import {DoctorExamineCreate} from "@/models/doctorExamineCreate";
import {EmployeeInHospital} from "@/models/employeeInHospital";

export default {

  setup(){
    const router = useRouter();
    const toast = useToast();
    const store = useStore();
    const error = ref(null);
    const listCustomer = ref([] as ListCustomer[]);
    const managerBooking = ref({} as ManagerBookingCreate);
    const listManagerBooking = ref([] as ManagerBooking[]);
    const doctorExamine = ref({} as DoctorExamineCreate);
    const listDoctorExamine = ref([] as DoctorExamineCreate[]);
    const listEmployeeInHospital = ref([] as EmployeeInHospital[]);

    const loadData = () => {
      zaloRepository.getListCustomer()
          .then((response) => {
            listCustomer.value = response.data;
            loadListManager();
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:'Lỗi khi tải danh sách khách hàng',
              life: 2000
            });
          });

      zaloRepository.getListDoctorExamine()
          .then((response) => {
            listDoctorExamine.value = response.data;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:'Lỗi khi tải danh sách bác sĩ',
              life: 2000
            });
          });

      zaloRepository.getListEmployeeInHospital()
          .then((response) => {
            listEmployeeInHospital.value = response.data;
            listEmployeeInHospital.value.forEach(x => x.fullNameWithPhone = x.fullName + " - " + x.phoneNumber);
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:'Lỗi khi tải danh sách bác sĩ',
              life: 2000
            });
          });
    }

    loadData();

    const loadListManager = () => {
      zaloRepository.getListManagerOfBooking()
          .then((response) => {
            listManagerBooking.value = response.data;
            listManagerBooking.value.forEach(x => {
              listCustomer.value.filter(y => {
                if(y.id == x.zaloId) x.imageLink = y.imageUrl;
              })
            });
            console.log("@@################### loadListManager listManagerBooking : " + JSON.stringify(listManagerBooking.value))
          })
          .catch(err => {
            // toast.add({
            //   severity: 'error',
            //   summary: 'Lỗi',
            //   detail:'Lỗi khi tải danh sách nhận góp ý',
            //   life: 2000
            // });
          });
    }



    const addMember = () => {
      listCustomer.value.forEach(x => {
        if(x.id == managerBooking.value.zaloId){
          managerBooking.value.fullName = x.name;
        }
      })
      zaloRepository.addManagerOfBooking(managerBooking.value)
          .then((response) => {
            toast.add({
              severity: 'success',
              summary: 'Thành công',
              detail: 'Thêm thành viên vào nhóm thành công',
              life: 2000
            });
            loadListManager();
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail: err.response.data,
              life: 2000
            });
          });
    }

    const addDoctor = () => {
      console.log("#########$$$$$$$$$$$$$$$$$ doctorExamine.value.zaloId: " + doctorExamine.value.zaloId);
      console.log("#########$$$$$$$$$$$$$$$$$ listEmployeeInHospital: " + JSON.stringify(listEmployeeInHospital.value));
      listEmployeeInHospital.value.forEach(x => {
        if(x.zaloId == doctorExamine.value.zaloId){
          console.log("#########$$$$$$$$$$$$$$$$$ x: " + JSON.stringify(x));
          doctorExamine.value.doctorName = x.fullName;
          doctorExamine.value.phoneNumber = x.phoneNumber;
        }
      })
      zaloRepository.createDoctorExamine(doctorExamine.value)
          .then((response) => {
            toast.add({
              severity: 'success',
              summary: 'Thành công',
              detail: 'Thêm bác sĩ thành công',
              life: 2000
            });
            zaloRepository.getListDoctorExamine()
                .then((response) => {
                  listDoctorExamine.value = response.data;
                })
                .catch(err => {
                  toast.add({
                    severity: 'error',
                    summary: 'Lỗi',
                    detail:'Lỗi khi tải danh sách bác sĩ',
                    life: 2000
                  });
                });
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail: err.response.data,
              life: 2000
            });
          });
    }

    const deleteDoctor = (id: number) => {
      zaloRepository.deleteDoctorExamine(id)
          .then((response) => {
            toast.add({
              severity: 'success',
              summary: 'Thành công',
              detail: 'Xóa bác sĩ thành công',
              life: 2000
            });
            zaloRepository.getListDoctorExamine()
                .then((response) => {
                  listDoctorExamine.value = response.data;
                })
                .catch(err => {
                  toast.add({
                    severity: 'error',
                    summary: 'Lỗi',
                    detail:'Lỗi khi tải danh sách bác sĩ',
                    life: 2000
                  });
                });
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail: err.response.data,
              life: 2000
            });
          });
    }

    const deleteManager = (id: number) => {
      zaloRepository.deleteManagerOfBooking(id)
          .then((response) => {
            toast.add({
              severity: 'success',
              summary: 'Thành công',
              detail: 'Xóa thành viên ra khỏi nhóm thành công',
              life: 2000
            });
            loadListManager();
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail: err.response.data,
              life: 2000
            });
          });
    }
    const filters = ref({
      'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
    });

    const clearFilter = () => {
      initFilters();
    };

    const initFilters = () => {
      filters.value = {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      }
    };

    return {
      error,
      managerBooking,
      listCustomer,
      addMember,
      deleteManager,
      listManagerBooking,
      filters,
      clearFilter,
      initFilters,
      listEmployeeInHospital,
      doctorExamine,
      listDoctorExamine,
      addDoctor,
      deleteDoctor
    }
  }
}

</script>
